import React from 'react';
import { SuitFor, typeMeta } from './Suit';
import { useT } from '../i18n/LanguageContext';

const tierClasses = {
  L10: 'bg-red-100 text-red-900 ring-1 ring-red-300',
  L9:  'bg-neutral-200 text-neutral-800 ring-1 ring-neutral-400',
  L8:  'bg-neutral-100 text-neutral-700 ring-1 ring-neutral-300',
  L7:  'bg-amber-100 text-amber-800 ring-1 ring-amber-300',
  L6:  'bg-stone-100 text-stone-700 ring-1 ring-stone-300',
};

const fmt = (n) => (n || 0).toLocaleString('en-US');

export default function FormationCard({ formation, limit }) {
  const { t } = useT();
  const items = formation.items.filter((it) => it.count > 0);
  const hero = formation.hero;
  const over = formation.total > limit;

  return (
    <div className="relative rounded-xl bg-white border border-neutral-200 shadow-[0_6px_18px_rgba(0,0,0,0.06)] overflow-hidden hover:shadow-[0_10px_30px_rgba(201,42,42,0.12)] transition-shadow">
      <div className="h-1 bg-gradient-to-r from-[#c92a2a] via-[#e03131] to-[#c92a2a]" />

      <div className="flex items-center justify-between px-5 py-3 border-b border-neutral-100 bg-neutral-50/60">
        <div className="flex items-center gap-2.5">
          <span className="inline-flex items-center justify-center w-8 h-8 rounded-md bg-[#0d0d0d] text-white font-black text-sm shadow-sm">
            {formation.index}
          </span>
          <h3 className="font-serif text-lg font-bold text-neutral-900 tracking-wide">
            {t('formation.title', { n: formation.index })}
          </h3>
        </div>
        {hero ? (
          <div className="flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#c92a2a] text-white text-xs font-bold shadow-sm">
            <SuitFor name={hero.suit} size={11} />
            <span>{hero.name}</span>
          </div>
        ) : (
          <span className="px-3 py-1 rounded-full bg-neutral-200 text-neutral-700 text-xs font-semibold tracking-wide">
            {t('formation.troopsOnly')}
          </span>
        )}
      </div>

      <div className="px-5 py-3">
        <ul className="divide-y divide-dashed divide-neutral-200">
          {items.map((it, idx) => {
            const meta = typeMeta[it.type];
            return (
              <li key={idx} className="flex items-center justify-between py-2">
                <div className="flex items-center gap-3">
                  <span className={`w-7 h-7 inline-flex items-center justify-center rounded-md ${meta.iconClass}`}>
                    <SuitFor name={meta.suit} size={14} />
                  </span>
                  <span className="font-medium text-neutral-900">{t(`troops.${it.type}`)}</span>
                  <span className={`px-2 py-0.5 rounded text-[11px] font-bold ${tierClasses[it.tier]}`}>{it.tier}</span>
                </div>
                <span className="font-semibold tabular-nums text-neutral-900">{fmt(it.count)}</span>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="px-5 py-3 border-t border-neutral-100 bg-neutral-50/60 flex items-center justify-between">
        <span className="font-semibold text-neutral-900">{t('formation.total')}</span>
        <span className={`font-bold tabular-nums ${over ? 'text-[#c92a2a]' : 'text-neutral-900'}`}>
          {fmt(formation.total)} / {fmt(limit)}
        </span>
      </div>
    </div>
  );
}
